import { render, staticRenderFns } from "./CartNumItems.vue?vue&type=template&id=e2b32d12&"
import script from "./CartNumItems.vue?vue&type=script&lang=js&"
export * from "./CartNumItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports